import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import CategoryLayout from 'components/shared/category/layout'
import Loader from 'components/loader'
import SearchMessage from '../search-message'
import SearchProducts from '../search-products'

const ValidSearchContent = ({
  filter,
  filterableCategories,
  isFetchData,
  isPhone,
  isSearching,
  loadMoreProducts,
  onSortFilterChanged,
  products,
  query,
  quickSizes,
  sortAndFilterData,
  t,
  totalHits,
  view,
}) => (
  <CategoryLayout
    isPhone={isPhone}
    isSearchPage
    relatedCategories={filterableCategories}
    setPageOne={onSortFilterChanged}
    sortFilterOptions={sortAndFilterData}
    t={t}
    title={query}
    quickSizes={quickSizes}
    totalProducts={totalHits}
  >
    {isFetchData && (
      <SearchMessage
        query={query}
        hitCount={totalHits}
        filter={filter}
        countProducts={products.length}
      />
    )}
    <SearchProducts
      hasMore={products?.length < totalHits}
      isFetchingProducts={isSearching.current}
      isPhone={isPhone}
      loadMoreProducts={loadMoreProducts}
      products={products}
      query={query}
      view={view}
    />
    {products?.length === 0 && !isFetchData && (
      <div className="loader-container">
        <Loader />
      </div>
    )}
  </CategoryLayout>
)

ValidSearchContent.defaultProps = {
  filterableCategories: null,
  isFetchData: false,
  products: [],
  query: '',
  quickSizes: [],
  totalHits: 0,
  view: null,
}

ValidSearchContent.propTypes = {
  filter: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filterableCategories: PropTypes.arrayOf(PropTypes.shape({})),
  isPhone: PropTypes.bool.isRequired,
  query: PropTypes.string,
  quickSizes: PropTypes.arrayOf(PropTypes.string),
  isFetchData: PropTypes.bool,
  isSearching: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  }).isRequired,
  loadMoreProducts: PropTypes.func.isRequired,
  onSortFilterChanged: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  sort: PropTypes.shape({ by: PropTypes.string }).isRequired,
  sortAndFilterData: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
  totalHits: PropTypes.number,
  view: PropTypes.string,
}

export default compose(
  connect((state) => ({
    filter: state.filter,
    isPhone: state.device.isPhone,
    sort: state.sort,
    view: state.visibility.view,
  })),
  withI18next(),
)(ValidSearchContent)
